import { Fragment, useContext, useEffect, useState } from "react";
import { MdDeleteOutline } from "react-icons/md";
import Container from "react-bootstrap/Container";
import AOS from "aos";
import { Card, Row, Col } from "react-bootstrap";
import ReactSelect from "react-select";
import { useForm, Controller } from "react-hook-form";
import "../pagesGlabal.css";
import { TextField } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import axios from "axios";
import { Server } from "../../../../constants";
import Spinner from "react-bootstrap/Spinner";
import { useHistory } from "react-router-dom";
import { verificarCedula } from 'udv-ec';
import InputMask from "react-input-mask";
import cuid from "cuid";
import Swal from "sweetalert2";
import Tooltip from '@material-ui/core/Tooltip';
import { DataContext } from "../../../pages/ConfiguraHyundai";

const Resumen = (props) => {
    const history = useHistory();
    const { control, handleSubmit, formState: { errors } } = useForm({
        defaultValues: {
            identificacion: "",
            nombre: "",
            apellido: "",
            telefono: "",
            direccion: "",
            correo: "",
            selectCiudad: "",
            selectConcesionario: "",
        }
    });
    const [pvpFinal, setPvpFinal] = useState(0);
    const [listaCiudades, setListaCiudades] = useState([]);
    const [listaConcesonarios, setListaConcesionarios] = useState([]);
    const [loading, setLoading] = useState(false);
    /* Variables para uso extra*/
    const [pvpTotalAccesorios, setPvpTotalAccesorios] = useState(0);
    const [pvpTotalKits, setPvpTotalKits] = useState(0);
    const [imagen, setImagen] = useState(null);
    const {
        accesoriosIndividuales,
        setAccesoriosIndividuales,
        kits,
        setKits,
        modeloSeleccionado,
    } = useContext(DataContext);

    useEffect(() => {
        try {
            let imgColor = require(`../../../../images/colores/${modeloSeleccionado.MOD_CODIGO}/${modeloSeleccionado?.colorSeleccionado?.VAC_COLOR}.webp`);
            setImagen(imgColor);
        } catch (error) {
            console.error('Error al cargar imagen en Resumen:', error);
            try {
                // Intentar sin versión
                let imgColor = require(`../../../../images/colores/${modeloSeleccionado.MOD_CODIGO}/${modeloSeleccionado?.colorSeleccionado?.VAC_COLOR}.webp`);
                setImagen(imgColor);
            } catch (defaultError) {
                console.error('Error al cargar imagen por defecto en Resumen:', defaultError);
                setImagen(null);
            }
        }
        AOS.init({
            duration: 2000
        });
        const obtenerPvpFinal = () => {
            var sumaKits = 0;
            var sumaAccesorios = 0;
            var sumaTotal = 0;
            kits.forEach((kit) => {
                sumaKits = sumaKits + kit.CK_PVP;
            })
            accesoriosIndividuales.forEach((accesorio) => {
                sumaAccesorios = sumaAccesorios + accesorio.CA_PVP;
            })
            sumaTotal = sumaKits + sumaAccesorios + modeloSeleccionado?.versionSeleccionada?.VEA_PRECIO_PVP;
            setPvpFinal(sumaTotal);
        };

        const obtenerCiudades = async () => {
            var url = "";
            url = `${Server}/api/ciudades/1/1-3/2`
            const response = await axios.get(url);
            var listaCiudadesSelect = response.data.map(
                (row) => {
                    return {
                        'id': row.CIU_CODIGO,
                        'value': row.CIU_NOMBRE,
                        'label': row.CIU_NOMBRE
                    }
                }
            )
            setListaCiudades(listaCiudadesSelect);
        };
        obtenerPvpFinal();
        obtenerCiudades();
    }, [accesoriosIndividuales, kits, modeloSeleccionado.versionSeleccionada.VEA_PRECIO_PVP]);

    const suprimirItem = (item, tipo) => {
        if (tipo === "KIT") {
            const nuevaLista = kits.filter((kit) => kit.CK_ID !== item.CK_ID)
            setKits(nuevaLista);
        } else {
            const nuevaLista = accesoriosIndividuales.filter((accesorio) => accesorio.CA_ID !== item.CA_ID)
            setAccesoriosIndividuales(nuevaLista);
        }
    }

    const onSubmit = (data) => {
        setLoading(true)
        enviarCotizacionPersonaliza(data);
    }

    const crearBodyKits = () => {
        let jsonkits = []
        let pvpKits = 0;
        kits.forEach(
            (kit) => {
                jsonkits.push({
                    // id: kit.CK_COD_SGC,
                    id: kit.CMK_COD_SGC,
                    dt2: kit.CK_NOMBRE_KIT,
                    dt3: modeloSeleccionado.MOD_NOMBRE,
                    ndt2: kit.CK_PVP,
                    dt10: "ACTIVO",
                    dt7: "Kit"
                });
                pvpKits = pvpKits + kit.CK_PVP;
            }
        )
        setPvpTotalKits(pvpKits);
        return JSON.stringify(jsonkits);
    }

    const crearBodyAccesorios = () => {
        let jsonAccesorios = []
        let pvpAccesorios = 0
        accesoriosIndividuales.forEach(
            (accesorio) => {
                jsonAccesorios.push({
                    // id: accesorio.CA_COD_SGC,
                    id: accesorio.CMK_COD_SGC,
                    dt2: accesorio.CA_NOMBRE_ACC,
                    dt3: modeloSeleccionado.MOD_NOMBRE,
                    ndt2: accesorio.CA_PVP,
                    dt10: "ACTIVO"
                });
                pvpAccesorios = pvpAccesorios + accesorio.CA_PVP;
            }
        )
        setPvpTotalAccesorios(pvpAccesorios);
        return JSON.stringify(jsonAccesorios);
    }

    const enviarCotizacionPersonaliza = async (data) => {
        let cid = cuid();
        const dataForm = new FormData();
        dataForm.append("id", cid);
        dataForm.append("ciudad", data.selectCiudad.value);
        dataForm.append("empresa", data.selectConcesionario.label);
        dataForm.append("identificacion", data.identificacion);
        dataForm.append("nombre", data.nombre);
        dataForm.append("apellido", data.apellido);
        dataForm.append("correo", data.correo);
        dataForm.append("direccion", data.direccion);
        dataForm.append("telefono", data.telefono.replaceAll(" ", ""));
        // //Campos Extras Integracion SGC
        dataForm.append("resumen_items", "");
        dataForm.append("cod_agencia_sgc", data.selectConcesionario.value);
        dataForm.append("cod_modelo_color_sgc", modeloSeleccionado.colorSeleccionado.VAC_COD_SGC);
        dataForm.append("cod_version_sgc", modeloSeleccionado.versionSeleccionada.VEA_COD_SGC);
        dataForm.append("cod_modelo_comercial_sgc", modeloSeleccionado.versionSeleccionada.VER_COD_SGC);
        dataForm.append("pvp_cotizacion", pvpFinal);
        dataForm.append("lista_accesorios", crearBodyAccesorios());
        dataForm.append("lista_kits", crearBodyKits());
        // Campos extras, solo para visualizar informacion
        dataForm.append("pvp_version", modeloSeleccionado?.versionSeleccionada?.VEA_PRECIO_PVP);
        dataForm.append("pvp_kits", pvpTotalKits);
        dataForm.append("color_version", modeloSeleccionado?.colorSeleccionado?.COL_NOMBRE);
        dataForm.append("pvp_accesorios", pvpTotalAccesorios);
        dataForm.append("nombre_modelo", modeloSeleccionado?.MOD_NOMBRE);
        dataForm.append("nombre_version", modeloSeleccionado?.versionSeleccionada?.VER_NOMBRE);
        const url = `${Server}/api/configura/ingresar-cotizacion`
        // Enviar prospecto
        await axios.post(
            url,
            dataForm
        ).then((respuesta) => {
            if (respuesta.data.mensaje.bdt1) {
                Swal.fire({
                    title: "ÉXITO",
                    text: "La información fue enviada con éxito",
                    showCloseButton: true,
                    icon: "success",
                });
                history.push(`/cotizador/gracias`);
            } else {
                Swal.fire({
                    title: "No se pudo enviar la información",
                    text: "Por favor intente nuevamente en unos minutos",
                    showCloseButton: true,
                    icon: "info",
                });
            }
        }).catch((err) => {
            Swal.fire({
                title: "Error al enviar la información",
                text: "Por favor intente en unos minutos",
                showCloseButton: true,
                icon: "error",
            });
        }).finally(() => {
            setLoading(false)
        })
    }

    //REST
    const leerCiudad = async (item) => {
        obtenerConcecionarios(item.id);
    }

    const obtenerConcecionarios = async (ciudad) => {
        let url = ""
        url = `${Server}/api/concesionarios/1/1-3/2/${ciudad}`
        const response = await axios.get(url);
        var listaConcesionariosSelect = response.data.map(
            (row) => {
                return {
                    'id': parseInt(row.ALM_COD_SGC),
                    'value': row.ALM_COD_SGC,
                    'label': `(${row.EMP_NOMBRE_COMERCIAL}) - ${row.ALM_NOMBRE} - ${row.ALM_DIRECCION}`
                }
            }
        )
        setListaConcesionarios(listaConcesionariosSelect)
    }

    return (
        <Fragment>
            <section>
                <Container>
                    <Row className="pt-5 pb-5">
                        <Col md={8} className="pr-md-5">
                            <Row className="centrar-global">
                                <div data-aos="fade-right">
                                    <img
                                        className="imagen-resumen"
                                        src={imagen}
                                        alt="modelo-vehiculo" />
                                    <h5 className="h-head-l h12 text-center">*Imagen referencial para uso
                                        publicitario.</h5>
                                </div>
                            </Row>
                            <Row>
                                <Col>
                                    <p className='h-head-r h20'>Resúmen de costos</p>
                                    <hr />
                                    <p className="h-head-r h18"><b>Versión</b></p>
                                    <Row>
                                        <Col>
                                            <p className="h-head-l h16"> {modeloSeleccionado?.versionSeleccionada?.VER_NOMBRE}</p>
                                        </Col>
                                        <Col className="text-right">
                                            <p className="precio">{modeloSeleccionado?.versionSeleccionada?.VEA_PRECIO_PVP.toLocaleString("en-US", {
                                                style: 'currency',
                                                currency: 'USD'
                                            })}</p>
                                        </Col>
                                    </Row>
                                    <hr />
                                    <p className="h-head-r h18"><b>Color</b></p>
                                    <p className="h-head-l h16"> {modeloSeleccionado?.colorSeleccionado?.COL_NOMBRE}</p>
                                    <hr />
                                    <Row>
                                        <Col>
                                            <p className="h-head-r  h18"><b>Paquetes Seleccionados</b></p>
                                            {
                                                kits?.map(kit => {
                                                    return <Row key={kit.CK_ID}>
                                                        <Col>
                                                            <div className="detalle">
                                                                <p className="h-head-l h16">
                                                                    {kit.CK_NOMBRE_KIT}
                                                                </p>
                                                                <Tooltip
                                                                    title="Eliminar"
                                                                    placement="right-start"
                                                                    arrow
                                                                >
                                                                    <span
                                                                        aria-label="delete"
                                                                    >
                                                                        <MdDeleteOutline
                                                                            id={kit.CK_ID}
                                                                            values={kit.CK_ID}
                                                                            className="icono"
                                                                            onClick={() =>
                                                                                suprimirItem(kit, "KIT")
                                                                            }
                                                                        />
                                                                    </span>
                                                                </Tooltip>
                                                            </div>
                                                        </Col>
                                                        <Col>
                                                            <p className="h-head-l h16 text-right precio">{kit.CK_PVP.toLocaleString("en-US", {
                                                                style: 'currency',
                                                                currency: 'USD'
                                                            })}</p>
                                                        </Col>
                                                    </Row>
                                                })
                                            }
                                        </Col>
                                    </Row>
                                    <hr />
                                    <Row>
                                        <Col>
                                            <p className="h-head-r  h18"><b>Accesorios Seleccionados</b></p>
                                            {
                                                accesoriosIndividuales?.map((item) => {
                                                    return <Row key={item.CA_ID}>
                                                        <Col>
                                                            <div className="detalle">
                                                                <p className="h-head-l h16">
                                                                    {item.CA_NOMBRE_ACC}
                                                                </p>
                                                                <Tooltip
                                                                    title="Eliminar"
                                                                    placement="right-start"
                                                                    arrow
                                                                >
                                                                    <span
                                                                    >
                                                                        <MdDeleteOutline
                                                                            className="icono"
                                                                            onClick={() =>
                                                                                suprimirItem(item, "ACCESORIO")
                                                                                //setOpen(true)
                                                                            }
                                                                        />
                                                                    </span>
                                                                </Tooltip>
                                                            </div>
                                                        </Col>
                                                        <Col>
                                                            <p className="h-head-l h16 text-right precio">
                                                                {item.CA_PVP.toLocaleString("en-US", {
                                                                    style: 'currency',
                                                                    currency: 'USD'
                                                                })}</p>
                                                        </Col>
                                                    </Row>
                                                })
                                            }
                                        </Col>
                                    </Row>
                                    <hr />
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <p className="h-head-r  h18"><b>TOTAL PVP</b></p>
                                    <p className="h-head-of h14">* Precios incluyen IVA</p>
                                </Col>
                                <Col className="text-right">
                                    <p className="h-head-of h18 precio">
                                        <b>{pvpFinal.toLocaleString("en-US", {
                                            style: 'currency',
                                            currency: 'USD'
                                        })}</b>
                                    </p>
                                </Col>
                            </Row>
                        </Col>
                        <Col md={4}>
                            <Row>
                                <Card className='card-contacto'>
                                    <Card.Body>
                                        <p className="h-head-r h20">Contactar a un asesor Hyundai</p>
                                        <p className="h-head-of h12">* Todos los campos son obligatorios</p>
                                        <form onSubmit={handleSubmit(onSubmit)}>
                                            <Controller
                                                rules={{
                                                    required: 'Identificación requerida',
                                                    validate: (value) =>
                                                        verificarCedula(value) || "Cédula incorrecta"
                                                }}
                                                name="identificacion"
                                                control={control}
                                                render={({ field: { onChange, value } }) =>
                                                    <InputMask
                                                        mask="9999999999"
                                                        maskChar=" "
                                                        name="identificacion"
                                                        value={value}
                                                        onChange={onChange}
                                                    >
                                                        {(inputProps) => (
                                                            <TextField
                                                                {...inputProps}
                                                                size="small"
                                                                placeholder="Identificación"
                                                                className="textField-contacto"
                                                                variant="outlined"
                                                                InputProps={{
                                                                    inputProps: {
                                                                        maxLength: 13,
                                                                    }
                                                                }}
                                                            />
                                                        )}
                                                    </InputMask>}
                                            />
                                            <span className="message-error">
                                                {errors.identificacion ? errors.identificacion.message : ""}
                                            </span>
                                            <Controller
                                                name="nombre"
                                                control={control}
                                                rules={{
                                                    required: 'Nombre requerido',
                                                }}
                                                render={({ field }) =>
                                                    <TextField
                                                        {...field}
                                                        size="small"
                                                        id="nombre"
                                                        placeholder="Nombres"
                                                        variant="outlined"
                                                        //onChange={event => setNombre(event.target.value)}
                                                        className="textField-contacto mt-2"
                                                    />}
                                            />
                                            <span className="message-error">
                                                {errors.nombre ? errors.nombre.message : ""}
                                            </span>
                                            <Controller
                                                name="apellido"
                                                control={control}
                                                rules={{
                                                    required: 'Apellido requerido',
                                                }}
                                                render={({ field }) =>
                                                    <TextField
                                                        {...field}
                                                        size="small"
                                                        id="apellido"
                                                        placeholder="Apellidos"
                                                        variant="outlined"
                                                        className="textField-contacto mt-2"
                                                    />}
                                            />
                                            <span className="message-error">
                                                {errors.apellido ? errors.apellido.message : ""}
                                            </span>
                                            <Controller
                                                rules={{ required: 'Teléfono requerido' }}
                                                name="telefono"
                                                control={control}
                                                render={({ field: { onChange, value } }) =>
                                                    <InputMask
                                                        id="telefono"
                                                        type="text"
                                                        mask="09 9999 9999"
                                                        maskChar=" "
                                                        value={value}
                                                        onChange={onChange}
                                                    >
                                                        {(inputProps) => (
                                                            <TextField
                                                                {...inputProps}
                                                                size="small"
                                                                placeholder="Teléfono"
                                                                className="textField-contacto mt-2"
                                                                variant="outlined"
                                                            />
                                                        )}
                                                    </InputMask>
                                                }
                                            />
                                            <span className="message-error">
                                                {errors.telefono ? errors.telefono.message : ""}
                                            </span>
                                            <Controller
                                                name="direccion"
                                                control={control}
                                                render={({ field }) =>
                                                    <TextField
                                                        {...field}
                                                        size="small"
                                                        id="direccion"
                                                        placeholder="Dirección"
                                                        //onChange={event => setDireccion(event.target.value)}
                                                        variant="outlined"
                                                        className="textField-contacto mt-2"
                                                    />}
                                            />
                                            <Controller
                                                rules={{
                                                    required: 'Correo requerido',
                                                    pattern: {
                                                        value: /^(([^<>()\]\\.,;:\s@”]+(\.[^<>()\]\\.,;:\s@”]+)*)|(“.+”))@((\[[0–9]{1,3}\.[0–9]{1,3}\.[0–9]{1,3}\.[0–9]{1,3}])|(([a-zA-Z\-0–9]+\.)+[a-zA-Z]{2,}))$/,
                                                        message: "Dirrección de correo no válido"
                                                    }
                                                }}
                                                name="correo"
                                                control={control}
                                                render={({ field }) =>
                                                    <TextField
                                                        {...field}
                                                        size="small"
                                                        id="correo"
                                                        // label="Correo"
                                                        placeholder="Correo"
                                                        //onChange={event => setDireccion(event.target.value)}
                                                        variant="outlined"
                                                        className="textField-contacto mt-2"
                                                    />}
                                            />
                                            <span className="message-error">
                                                {errors.correo ? errors.correo.message : ""}
                                            </span>
                                            <Controller
                                                rules={{ required: 'Ciudad requerida' }}
                                                name="selectCiudad"
                                                control={control}

                                                render={({ field: { onChange } }) =>
                                                    <ReactSelect
                                                        onChange={(item) => {
                                                            onChange(item);
                                                            leerCiudad(item);
                                                        }}
                                                        placeholder='Ciudad'
                                                        options={listaCiudades}
                                                        className='label-txtfield mt-2'
                                                        theme={(theme) => ({
                                                            ...theme,
                                                            colors: {
                                                                ...theme.colors,
                                                                primary: '#002c5f',
                                                            },

                                                        })}
                                                    />
                                                }
                                            />
                                            {errors.selectCiudad ?
                                                <span className="message-error">
                                                    {errors.selectCiudad.message}
                                                </span>
                                                : null
                                            }
                                            <Controller
                                                rules={{ required: 'Concesionario requerido' }}
                                                name="selectConcesionario"
                                                control={control}
                                                render={({ field }) =>
                                                    <ReactSelect
                                                        {...field}
                                                        placeholder='Concesionario'
                                                        options={listaConcesonarios}
                                                        className='label-txtfield mt-2'
                                                        theme={(theme) => ({
                                                            ...theme,
                                                            colors: {
                                                                ...theme.colors,
                                                                primary: '#002c5f',
                                                            },

                                                        })}
                                                    />
                                                }
                                            />
                                            <span className="message-error">
                                                {errors.selectConcesionario ? errors.selectConcesionario.message : ""}
                                            </span>
                                            <p className="mt-2 pl-md-4 titulo-legal">
                                                Términos y condiciones
                                            </p>
                                            <p className=" pr-md-3 pl-md-4 texto-legal">
                                                Autorizo de manera expresa, inequívoca y voluntaria a HYUNDAI ECUADOR y todas sus 
                                                compañías relacionadas, para recopilar, tratar, transferir a terceros y conservar 
                                                mis datos personales y crediticios, así como para su revisión ante el buró de 
                                                crédito con la finalidad de cotizar el vehículo, y recibir comunicaciones o 
                                                notificaciones sobre sus productos y servicios. Además los valores calculados 
                                                son referenciales y bajo ninguna circunstancia representan un compromiso de venta. 
                                                Estos valores están sujetos a variaciones. Las fotografías son referenciales, 
                                                el modelo y accesorios pueden variar en el punto de venta.
                                            </p>
                                            {
                                                !loading ?
                                                    <Button type="submit"
                                                        className='btn-main mt-5'
                                                    >
                                                        Solicitar Cotización
                                                    </Button>
                                                    :
                                                    <Button type="submit"

                                                        className='btn-main mt-5'
                                                        disabled={true}
                                                    >
                                                        Enviando... <Spinner></Spinner>
                                                    </Button>
                                            }
                                        </form>
                                    </Card.Body>
                                </Card>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </section>
        </Fragment>

    );
};

export default Resumen;
